import React from 'react';

/**
 * VerifyPro brand lockup — renders the official logo artwork
 * (/brand/verifypro-logo.png, white variant for dark surfaces).
 * `markClass` controls the rendered height; `textClass` is kept for API
 * compatibility with existing call-sites.
 */
export const BrandLogo = ({
  surface = 'light',
  showTagline = false,
  markClass = 'h-8 w-auto',
  textClass = '',
  className = '',
  ...rest
}) => {
  const isDark = surface === 'dark';
  const src = isDark ? '/brand/verifypro-logo-white.png' : '/brand/verifypro-logo.png';
  return (
    <span className={`inline-flex flex-col items-start ${className}`} data-testid="brand-logo" {...rest}>
      <img src={src} alt="VerifyPro" className={`${markClass} shrink-0 object-contain`} />
      {showTagline && (
        <span className={`mt-1.5 text-[9px] font-semibold tracking-[0.22em] ${isDark ? 'text-white/45' : 'text-brand-ink/45'}`}>
          POWERED BY INFINI10
        </span>
      )}
    </span>
  );
};

export default BrandLogo;
